var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { useFocusRing } from '@react-aria/focus';
import { CustomComponent } from '../../utils/CustomComponent';
import { applyMargins } from '../../utils/tailwind';
import { CircularLoader } from '../Loader/CircularLoader';
import { SuperEllipse } from '../SuperEllipse/SuperEllipse';
import { sizesMapping } from '../SuperEllipse/SuperEllipseIcon';
import { DEFAULT_VARIANT, VARIANT_MAPPING, iconButton } from './styles';
export * from './types';
const IconButtonComponent = (_a, ref) => {
    var { component = 'button', variant = DEFAULT_VARIANT, size, name, disabled, loading, badge, className, iconProps } = _a, props = __rest(_a, ["component", "variant", "size", "name", "disabled", "loading", "badge", "className", "iconProps"]);
    const [isHovered, setIsHovered] = useState(false);
    const { isFocusVisible, focusProps } = useFocusRing();
    const loaderSize = sizesMapping[size];
    const isDisabled = disabled || loading;
    const colorSet = VARIANT_MAPPING[variant];
    return (_jsx(CustomComponent, Object.assign({ as: component, className: iconButton({
            disabled: isDisabled,
            className: [applyMargins(props), className],
        }), disabled: isDisabled, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), type: "button" }, focusProps, props, { ref: ref, children: _jsx(SuperEllipse, Object.assign({ size: size }, (loading ? {} : { icon: name }), { colorSet: isDisabled ? `${colorSet}.disabled` : isHovered ? `${colorSet}.hover` : colorSet, highlight: isFocusVisible, badge: badge, iconProps: iconProps, children: loading && _jsx(CircularLoader, { size: loaderSize, colorSet: "interactive.secondary.disabled" }) })) })));
};
export const IconButton = forwardRef(IconButtonComponent);
